<template>
  <el-form style="margin: 0 10px" ref="form" :model="form" label-position="top">
    <el-form-item label="插件Id">
      {{ extension.userName }}.{{ extension.name }}
    </el-form-item>
    <el-form-item label="标签">
      <el-select
        v-model="form.keywords"
        style="width: 100%;"
        size="small"
        multiple
        filterable
        allow-create
        default-first-option
        placeholder="请选择内容标签">
        <el-option
          v-for="tagName in form.keywords"
          :key="tagName"
          :label="tagName"
          :value="tagName">
        </el-option>
      </el-select>
    </el-form-item>
  </el-form>

  <el-divider></el-divider>

  <div class="el-dialog__footer">
    <el-button type="primary" @click="btnSubmitClick">确 定</el-button>
    <el-button @click="btnCancelClick">取 消</el-button>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { IElForm } from '@/types/element';
import { IExtension } from '@/types/models';
import utils from '@/utils';
import api from '@/api/admin/extensions';

export default defineComponent({
  emits: ['cancel', 'submit'],
  props: {
    extension: {
      type: Object as PropType<IExtension>,
      required: true,
    },
  },
  data() {
    return {
      form: { ...this.extension },
    };
  },
  methods: {
    apiSubmit() {
      api.setTags(this.form, (res) => {
        if (!res) return;

        utils.success('插件标签设置成功！');
        this.$emit('submit', this.form);
      });
    },

    btnCancelClick() {
      this.$emit('cancel');
    },

    btnSubmitClick() {
      (this.$refs.form as IElForm).validate((valid) => {
        if (valid) {
          this.apiSubmit();
        }
      });
    },
  },
  watch: {
    extension(value) {
      this.form = { ...value };
    },
  },
});
</script>
